<!--  -->
<template>
  <div class="app-content">
    <div class="hint-area">
      <div class="hint-context">
        <div class="hint-title">添加牌位</div>
        <div class="hint-word">请注意，所有祭主必须为同一辈分</div>
      </div>
    </div>
    <div v-for="(card, cardIndex) in cardObj"
         :key="cardIndex"
         class="info-area">
      <div class="info-item">
        <div class="cell-area">
          <div class="cell-title">亡人信息</div>
          <img @click="deleteInfo(cardIndex)"
               src="../assets/delete.png"
               class="icon-delete">
          <div class="cell"
               style="border: none;">
            <van-field v-model="card.type"
                       label-align="left"
                       :label="'超度类别'"
                       placeholder="请选择"
                       readonly="readonly"
                       @click="card.leibie = true"
                       :rules="rules.type" />
            <img src="../assets/jiantouyou.png"
                 class="choose-arrow">
          </div>
          <div v-if="card.bottomAreaAll">
            <!-- 被超度人 -->
            <div v-if="card.showSacrificerInputs">
              <van-field v-model="card.relativeName"
                         :rules="rules.relativeName"
                         :label="'某氏 '"
                         :placeholder="'请输入姓氏'" />
            </div>
            <!-- 被超度人选项 + 姓名 -->
            <div v-if="card.showSacrificerInputs2">
              <div v-for="(relative, index) in card.items"
                   :key="index"
                   class="cell">
                <van-field v-model="relative.identity"
                           :label="'被超度人'"
                           readonly="readonly"
                           :rules="rules.identity"
                           :placeholder="'请选择'"
                           @click="card.leibieInfo = true, card.relativeNamesObjIndex = index" />
                <img src="../assets/jiantouyou.png"
                     class="choose-arrow">
                <van-field style="width: 60%; margin-left: 20px"
                           v-model="relative.name"
                           @change="changeItemName(cardIndex, index)"
                           :placeholder="'请输入亡者姓名'" />
              </div>
            </div>
            <div class="cell-alive-title"
                 style="">祭主(阳上)信息</div>
            <!-- 祭主表单 -->
            <div>
              <van-field v-for="(sacrificer, index) in card.jzs"
                         :key="index"
                         :rules="rules.jzs"
                         v-model="card.jzs[index]"
                         @change="changeJzsValue(cardIndex, index)"
                         :value="sacrificer"
                         :label="'祭主' + (index + 1)"
                         placeholder="请输入祭主姓名" />
            </div>
          </div>
          <div class="bottom-area"
               @click="card.bottomAreaAll = !card.bottomAreaAll">
            <img v-if="card.bottomAreaAll"
                 src="../assets/shouqijiantou.png"
                 style="width: 16px; height: 16px; margin-top: 7px; margin-left: calc(-35px + 50vw);">
            <div v-if="card.bottomAreaAll"
                 style="margin-left: 2px;">收起</div>
            <img v-if="!card.bottomAreaAll"
                 src="../assets/shouqijiantou.png"
                 style="width: 16px; height: 16px; margin-top: 7px; margin-left: calc(-35px + 50vw); transform: rotate(180deg);">
            <div v-if="!card.bottomAreaAll"
                 style="margin-left: 2px;">展开</div>
          </div>
          <!-- 超度类别弹出层 -->
          <van-popup v-model="card.leibie"
                     position="bottom"
                     round>
            <van-picker class="danxiang-style"
                        show-toolbar
                        :columns="userState"
                        value-key="value"
                        v-model="card.type"
                        type="date"
                        title=""
                        @confirm="handlePickerConfirm(cardIndex, $event)"
                        @cancel="onCancel"
                        @change="onChange" />
          </van-popup>
          <!-- 超度类别选项详细弹出层 -->
          <van-popup v-model="card.leibieInfo"
                     position="bottom"
                     round>
            <van-picker class="danxiang-style"
                        show-toolbar
                        :columns="card.convertedArray"
                        value-key="value"
                        v-model="card.type"
                        type="date"
                        title=""
                        @confirm="leibieInfoConfirm(cardIndex, $event)"
                        @cancel="onCancel"
                        @change="onChange" />
          </van-popup>
        </div>
      </div>
    </div>
    <div class="add-more"
         @click="addCard">新增更多牌位</div>
    <div class="money-container">
      <div class="money-title">功德经资<span class="price-type">按牌位单价</span></div>
      <div class="money-select-block">
        <div class="money-item-wrap"
             v-for="(memorial, index) in meetingInfo?.memorials"
             :key="index">
          <div class="money-item money-item-selected"
               :class="getButtonClass(index)"
               @click="selectPrice(memorial, index)">
            {{ memorial.price }}
          </div>
        </div>
      </div>
      <div class="cell">
        <div class="label">功德经资</div>
        <div class="label"
             style="flex: 1 1 0%; display: flex; align-items: center;">
          <div class="buyer-info-input"
               style="margin-left: 20px; line-height: 20px; color: rgba(0, 0, 0, 0.6);">
            {{ selectMemorialStr?.name }} {{ selectMemorialStr?.price }}元/牌位
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="money-container">
      <div class="label"
           style="display:flex;margin-bottom:10px;font-weight: 600">邮寄到家(到付)</div>
      <van-radio-group v-model="isYj"
                       direction="horizontal"
                       @change="onRadioChange">
        <van-radio name="0">不邮寄</van-radio>
        <van-radio name="1">邮寄</van-radio>
      </van-radio-group>
    </div> -->
    <div style="width: 100%; height: 90px;"></div>
    <div class="bottom-container">
      <div class="money-detail-wrap"
           style="display: flex;">
        <div class="money-wrap">
          <span class="symbol">¥</span>
          <span class="money">{{ selectMemorialStr?.price * cardObj.length }}</span>
        </div>
        <div class="detail-wrap"
             @click="showPriceDetail = !showPriceDetail">
          <span class="detail-text">明细</span>
          <img src="../assets/mingxijiantou.png"
               alt="arrow-down"
               class="order-price-fold">
        </div>
      </div>
      <div class="submit-order"
           @click="nextBtn">下一步</div>
    </div>
    <div class="price-detail-mask"
         style="display: none;"></div>
    <van-popup v-model="showPriceDetail"
               position="bottom"
               round>
      <img src="../assets/close.png"
           alt="close"
           @click="showPriceDetail = false">
      <div class="detail-title">价格明细</div>
      <div class="cell">
        <div class="title">功德经资</div>
        <div class="money">¥{{ selectMemorialStr?.price }}</div>
      </div>
    </van-popup>
    <div class="mint-popup mint-popup-bottom"
         style="display: none;">
      <div class="picker">
        <div class="picker-toolbar">
          <div class="mint-datetime-action mint-datetime-cancel">取消</div>
          <div class="mint-datetime-action mint-datetime-confirm">确定</div>
        </div>
        <div class="picker-items">
          <div class="picker-slot picker-slot-center">
            <div class="picker-slot-wrapper"
                 style="height: 180px; transform: translate(0px, 72px) translateZ(0px);">
              <div class="picker-item picker-selected"
                   style="height: 36px; line-height: 36px;">
                无祀孤魂
              </div>
            </div>
          </div>
          <div class="picker-center-highlight"
               style="height: 36px; margin-top: -18px;"></div>
        </div>
      </div>
    </div>
    <div class="mint-popup mint-popup-bottom"
         style="display: none;">
      <div class="picker">
        <div class="picker-toolbar">
          <div class="mint-datetime-action mint-datetime-cancel">取消</div>
          <div class="mint-datetime-action mint-datetime-confirm">确定</div>
        </div>
        <div class="picker-items">
          <div class="picker-slot picker-slot-center">
            <div class="picker-slot-wrapper"
                 style="height: 180px; transform: translate(0px, 0px) translateZ(0px);">
            </div>
          </div>
          <div class="picker-center-highlight"
               style="height: 36px; margin-top: -18px;"></div>
        </div>
      </div>
    </div>
    <div class="mint-popup mint-popup-bottom"
         style="display: none;">
      <div class="picker">
        <div class="picker-toolbar">
          <div class="mint-datetime-action mint-datetime-cancel">取消</div>
          <div class="mint-datetime-action mint-datetime-confirm">确定</div>
        </div>
        <div class="picker-items">
          <div class="picker-slot picker-slot-center">
            <div class="picker-slot-wrapper"
                 style="height: 180px; transform: translate(0px, 72px) translateZ(0px);">
              <div class="picker-item picker-selected"
                   style="height: 36px; line-height: 36px;">
                外坛小牌位
              </div>
              <div class="picker-item"
                   style="height: 36px; line-height: 36px;">
                主坛大牌位
              </div>
            </div>
          </div>
          <div class="picker-center-highlight"
               style="height: 36px; margin-top: -18px;"></div>
        </div>
      </div>
    </div>
    <homeBtn />
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import categoriesArray from '../utils/categories';
import homeBtn from './homeBtn.vue'//首页按钮

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    homeBtn
  },
  data() {
    // 这里存放数据
    return {
      // isYj: '0',
      cardObj: [{
        // 超度类别相关
        leibie: false,
        type: '',
        // 底部区域展开收起相关
        bottomAreaAll: false,
        showSacrificerInputs: false,
        showSacrificerInputs2: false,
        // 被超度人相关（单一输入框形式）
        relativeName: '',
        // 被超度人相关（选项 + 姓名输入框形式）
        items: [{ identity: "", name: "" }, { identity: "", name: "" }, { identity: "", name: "" }
        ],
        relativeNamesObjIndex: 0,
        // 祭主相关
        jzs: [''],
        convertedArray: [],//被超度人
        // 超度类别选项详细弹出层相关
        leibieInfo: false
      }],
      memorialsItems: [
        {
          items: [{
            identity: "",
            name: ""
          },
          {
            identity: "",
            name: ""
          },
          {
            identity: "",
            name: ""
          }],
          jzs: [],
          type: ""
        }
      ],
      showPicker: false,
      convertedArray: [],//被超度人
      sacrificerInfos: [],
      relativeName: "",
      leibie: false,
      userState: categoriesArray,
      showPriceDetail: false,
      relativeList: ['无祀孤魂', '普利十方', '冤亲债主', '*氏门中历代宗亲', '胎伤婴灵'],
      meetingInfo: {},
      selectPriceIndex: 0,
      selectMemorialStr: {},
      rules: {
        type: [
          { required: true, message: '请选择超度类别' }
        ],
        relativeName: [
          { required: true, message: '请输入姓氏' }
        ],
        items: [
          { required: true, message: '至少需要选择一位被超度的对象' }
        ],
        jzs: [
          { required: true, message: '至少需要输入一位祭主的信息' },
        ],
        name: [
          { required: true, message: '请输入被超度人姓名' }
        ],
        identity: [
          { required: true, message: '请选择被超度对象' }
        ]
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // onRadioChange(value) {
    //   console.log(`Selected value: ${value}`);
    //   localStorage.setItem('isYj', value);
    // },
    nextBtn() {
      let isValid = true;
      const forms = this.cardObj;
      const rules = this.rules;
      for (const form of forms) {
        Object.keys(rules).forEach(field => {
          const fieldRules = rules[field];
          const value = form[field];
          if (!form.type) {
            this.$toast(rules.type[0].message);
            isValid = false;
            return;
          } else if (field == 'type') {
            const typeValue = form.type;
            if (typeValue == '*氏门中历代宗亲') {
              // 先校验relativeName（祭主姓名）字段
              if (!form.relativeName) {
                this.$toast(rules.relativeName[0].message);
                isValid = false;
                return;
              }
              // 再校验jzs（被超度对象）字段
              if (form.jzs.length == 0 || form.jzs.every(jz => !jz)) {
                this.$toast(rules.jzs[0].message);
                isValid = false;
                return;
              }
            } else if (!this.relativeList.includes(typeValue)) {
              // 校验items中必须有一个对象的name和identity不为空
              let hasValidItem = false;
              for (const item of form.items) {
                if (item.name && item.identity) {
                  hasValidItem = true;
                  break;
                }
              }
              if (!hasValidItem) {
                for (const item of form.items) {
                  console.log(item)
                  if (item.name == "" && item.identity != "") {
                    this.$toast(rules.name[0].message);
                  } else if (item.name != "" && item.identity == "") {
                    this.$toast(rules.identity[0].message);
                  } else {
                    this.$toast(rules.items[0].message);
                  }
                  isValid = false;
                  return;
                }
              }
              // 再校验jzs（被超度对象）字段
              if (form.jzs.length == 0 || form.jzs.every(jz => !jz)) {
                this.$toast(rules.jzs[0].message);
                isValid = false;
                return;
              }

            } else {
              if (form.jzs.length == 0 || form.jzs.every(jz => !jz)) {
                this.$toast(rules.jzs[0].message);
                isValid = false;
                return;
              }
            }
          }
        });
      }
      if (isValid) {
        this.meetingInfo.price = this.selectMemorialStr.price
        this.meetingInfo.sumPrice = this.selectMemorialStr.price * this.memorialsItems.length
        console.log(this.memorialsItems)
        console.log(this.memorialsItems.length)
        localStorage.setItem("memorialsItems", JSON.stringify(this.memorialsItems))
        localStorage.setItem("meetingInfo", JSON.stringify(this.meetingInfo))
        if (this.meetingInfo.agencies[0].name != "") {
          this.$router.push('/fawuqingfeng')
        } else {
          this.$router.push('/querenxinxi')
        }
      }



    },
    selectPrice(memorial, index) {
      this.selectPriceIndex = index
      this.selectMemorialStr = memorial
    },
    getButtonClass(index) {
      return this.selectPriceIndex === index ? 'contact-item-selected' : '';
    },
    addCard() {
      this.cardObj.push({
        leibie: false,
        bottomAreaAll: false,
        relativeName: '',
        items: [
          {
            identity: "",
            name: ""
          },
          {
            identity: "",
            name: ""
          },
          {
            identity: "",
            name: ""
          }
        ],
        jzs: [''],
        leibieInfo: false,
        relativeNamesObjIndex: 0,
        type: ''
      });
      this.memorialsItems.push({
        items: [{
          identity: "",
          name: ""
        },
        {
          identity: "",
          name: ""
        },
        {
          identity: "",
          name: ""
        }],
        jzs: [],
        type: ""
      })
    },
    deleteInfo(cardIndex) {
      this.cardObj.splice(cardIndex, 1);
      this.memorialsItems.splice(cardIndex, 1);
    },
    // 打开超度类别弹出层的事件处理
    openLeibiePopup(cardIndex) {
      this.cardObj[cardIndex].leibie = true;
    },

    // 打开超度类别选项详细弹出层的事件处理
    openLeibieInfoPopup(cardIndex, index) {
      const card = this.cardObj[cardIndex];
      card.leibieInfo = true;
      card.relativeNamesObjIndex = index;
    },

    // 切换底部区域展开收起状态的事件处理
    toggleBottomArea(cardIndex) {
      this.cardObj[cardIndex].bottomAreaAll = !this.cardObj[cardIndex].bottomAreaAll;
    },

    // 超度类别弹出层确认
    handlePickerConfirm(index, selectedValues) {
      const selectedValue = selectedValues.value;
      this.cardObj.forEach((card, cardIndex) => {
        if (card.leibie) {
          card.type = selectedValue;
          card.showSacrificerInputs = card.type === "*氏门中历代宗亲" || card.type === "";
          card.showSacrificerInputs2 = card.type != '' && !this.relativeList.includes(card.type);
          this.updateSacrificerNamesBasedOnSuperCategory(card);
          this.convertStringToArray(card);
          card.leibie = false;
          card.bottomAreaAll = true;
          this.memorialsItems[index].type = selectedValue
          console.log(`卡片${cardIndex}选择了超度类别：${selectedValue}`);
        }
      });
    },
    //被超度人类别选项姓名输入事件
    changeItemName(cardIndex, index) {
      this.memorialsItems[cardIndex].items[index].name = this.cardObj[cardIndex].items[index].name
    },
    //祭主输入框事件
    changeJzsValue(cardIndex, index) {
      this.memorialsItems[cardIndex].jzs[index] = this.cardObj[cardIndex].jzs[index]
    },
    // 根据超度类别初始化祭主数量的方法
    updateSacrificerNamesBasedOnSuperCategory(card) {
      if (card.type !== '胎伤婴灵' && card.type !== '') {
        card.jzs = new Array(4).fill('');
      } else if (card.type === '胎伤婴灵') {
        card.jzs = new Array(2).fill('');
      } else {
        card.jzs = new Array(1).fill('');
      }
    },

    // 超度类别选项赋值的方法
    convertStringToArray(card) {
      const newArray = [{ label: '请选择', value: '请选择' }];
      const parts = card.type.split('、');
      parts.forEach(part => {
        newArray.push({ label: part, value: part });
      });
      card.convertedArray = newArray;
    },

    // 处理超度类别选项详细弹出层确认选择的事件处理
    leibieInfoConfirm(index, selectedValues) {
      const selectedValue = selectedValues.value;

      this.cardObj.forEach(card => {
        const relativeIndex = card.relativeNamesObjIndex;
        if (selectedValue != "请选择") {
          if (card.leibieInfo) {
            card.items[relativeIndex].identity = selectedValue;
            this.memorialsItems[index].items[relativeIndex].identity = selectedValue
          }
        } else {
          card.items[relativeIndex].identity = '';
          this.memorialsItems[index].items[relativeIndex].identity = ''
        }
        card.leibieInfo = false
      });


    },

    onCancel() {
      this.cardObj.forEach(card => {
        card.leibie = false;
        card.leibieInfo = false;
      });
    },

    onConfirm() {

    },
    goHome() {
      console.log(11111)
      this.$router.push("/")
    },
    closePriceDetail() {
      // 处理关闭价格明细的逻辑
    },
    onChange() {


    },
  },
  // 生命周期-创建完成（可以访问当前this实例）
  created() {
    this.meetingInfo = JSON.parse(localStorage.getItem("meetingInfo"))
    this.selectMemorialStr = JSON.parse(this.meetingInfo?.memorialStr)[0]
    // localStorage.setItem("isYj", '0');
  },
  // 生命周期-挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, // 生命周期-创建之前
  beforeMount() { }, // 生命周期-挂载之前
  beforeUpdate() { }, // 生命周期-更新之前
  updated() { }, // 生命周期-更新之后
  beforeDestroy() { }, // 生命周期-销毁之前
  destroyed() { }, // 生命周期-销毁完成
  activated() { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
/* 头部样式 */
.app-content {
  height: 100%;
  width: 100%;
  padding-bottom: 82px;
}

.hint-area {
  width: 100%;
  height: 136px;
  background: linear-gradient(133deg, #007aaa, #004e93);
  z-index: 1;
}

.hint-context {
  width: calc(100vw - 24px);
  height: 85px;
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  z-index: 5;
  position: absolute;
  top: 16px;
  left: 12px;
}

.hint-title {
  width: 100px;
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000;
  line-height: 25px;
  text-align: left;
  position: absolute;
  top: 16px;
  left: 12px;
}

.hint-word {
  width: 250px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  line-height: 20px;
  text-align: left;
  position: absolute;
  top: 49px;
  left: 12px;
}

/* 亡人信息卡片样式************* */
::v-deep .van-picker__toolbar {
  border-bottom: 1px solid #eaeaea;
  height: 45px;
}

::v-deep .van-picker__toolbar button {
  width: auto;
  line-height: 45px;
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #007aaa;
  font-weight: 400;
}

::v-deep
  .danxiang-style.van-picker
  .van-picker__columns
  .van-picker-column
  ul
  .van-picker-column__item--selected
  .van-ellipsis {
  padding: 2px 10px;
  font-family: PingFangSC-Semibold;
  font-size: 20px;
  color: #007aaa;
  font-weight: 600;
}

.info-area {
  width: 100%;
  position: relative;
  top: -32px;
}

.info-item {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  position: relative;
  top: -16px;
  margin-top: 16px;
}

.cell-area {
  width: calc(100vw - 24px);
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  position: relative;
  top: 16px;
  left: 12px;
}

.cell-title {
  width: 64px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000;
  line-height: 22px;
  position: relative;
  top: 16px;
  left: 14px;
}

.icon-delete {
  width: 16px;
  height: 16px;
  position: relative;
  top: -4px;
  left: calc(100vw - 52px);
}

.cell-area .cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin: 0 14px;
  padding: 14px 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  height: 48px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.cell-area .cell .title {
  width: 60px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
}

.color-gray {
  color: rgba(0, 0, 0, 0.2);
}

.cell .div-content {
  -webkit-box-flex: 5;
  -ms-flex-positive: 5;
  flex-grow: 5;
  padding-left: 2px;
}

.cell .div-content[data-v-2a9d70bc],
.cell .input-content {
  margin-left: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.contact-item-selected {
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAACAklEQVRIS7WUT0gUYRjGf++2q4IpgUVdukSXDtFRD3ZRgqDoUDQieegQCUHRZU1nCbZwF6SORVR0kqCdRUxBL13sVpHgpcCDhzpEZLTiLii77r4xq2Iz+2fGbXau3/M9v/d553tfwe8Xtw5S4AJKH3AGOAHSCdpaz0I8/Uetk4T0Hsgg0O6pdwlqA27Pt9KZfYjKXaBlv8a7+uqAqHWMCNNAT6PGtQH3rdMUmQOO/6+5fd+ZYLvyT0GZOwF2zztyC0G05d/kewliqQlURoJoSyWg/BT50uBryaA6S0iOopx3F7idwEy9BLnRQPU5pHSOyMYShfa5nSF02Aj2hOb52cAQbRKWi4QOvye/OgVcqlagELMGUN5UHCpFpAxuA7pc51uoXiVpzGBak4hcq5VeMK3nwM0qggwa7iHX9o2OnD0X/TuaEsJ1EsYkZvop6K36u8i0PgDdNUTfkWIvmQMZDvEOpBvROySMJ5ipJMiY13+zE/wCjtQRLqOcRQtbhCOXGTdeEUuPoDrhZQ5kBTO96bVyERYJ5/t4MLTOWHoY0WcVW6A6bdlOoD4qsSUfQRagFAUJ+boj8no/AF+eziEQo4kAXeH32qkmAUQRvULCmG4SgEckjfLiDBggCvqYlq+jxOOlgAG6gkjUbotzXft/pu5XlAV+IPIZmGH1z1teDBfcor8U96Nek6aSIwAAAABJRU5ErkJggg==);
  background-repeat: no-repeat;
  background-position: right -1px bottom;
  background-size: 12px;
  color: #007aaa;
  background-color: rgba(0, 122, 170, 0.05);
  border: 1px solid #007aaa;
}

/* 底部容器样式 */
.bottom-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 72px;
  background-color: #fff;
  -webkit-box-shadow: inset 0 1px 0 0 #eee;
  box-shadow: inset 0 1px 0 0 #eee;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 32px;
}

.bottom-container .money-wrap .symbol {
  font-size: 14px;
  color: #e65c2e;
  font-weight: 700;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
}

.bottom-container .money-wrap .money {
  font-size: 20px;
  color: #e65c2e;
  font-weight: 700;
  font-family: HelveticaNeue-Bold, HelveticaNeue;
}

.bottom-container .detail-wrap {
  margin: 2px 0 2px 8px;
}

.detail-wrap img {
  margin-left: 5px;
}

.bottom-container .detail-wrap .detail-text {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  font-family: PingFangSC-Regular, PingFang SC;
}

.bottom-container .detail-wrap > img {
  width: 14px;
  height: 14px;
  vertical-align: bottom;
  -webkit-transition: -webkit-transform 0.5s;
  transition: -webkit-transform 0.5s;
  transition: transform 0.5s;
  transition: transform 0.5s, -webkit-transform 0.5s;
}

.submit-order {
  width: 160px;
  height: 40px;
  line-height: 40px;
  background: linear-gradient(133deg, #007aaa, #004e93);
  border-radius: 22px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  -webkit-box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  box-shadow: 0 0 8px 0 rgba(19, 190, 191, 0.2);
  font-family: PingFangSC-Regular, PingFang SC;
}

.add-more {
  width: 160px;
  height: 40px;
  background: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 122, 170, 0.2);
  box-shadow: 0 0 8px 0 rgba(0, 122, 170, 0.2);
  border-radius: 22px;
  border: 1px solid #007aaa;
  font-size: 16px;
  line-height: 40px;
  position: relative;
  top: -8px;
  left: calc(50vw - 80px);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #007aaa;
  text-align: center;
}

.cell-area .cell .van-field,
.cell-area .cell-text-container .van-field {
  padding: 12px 0 !important;
}

.bottom-area {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #007aaa;
  text-align: center;
  width: 100%;
  height: 30px;
  font-size: 14px;
  line-height: 30px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.cell-alive-title {
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  height: 38px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000;
  line-height: 38px;
  position: relative;
  left: 14px;
  top: 0;
}

.cell-alive-list {
  margin: 0 14px;
  padding: 14px 0;
}

.cell-alive-list .van-field {
  padding: 12px 0 !important;
}

.cell-alive-list .van-field:not(:last-of-type) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.choose-arrow {
  width: 7px;
  height: 11px;
}

/* 功德经资卡片****************** */
.money-container {
  margin: 16px 12px 0;
  background-color: #fff;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  padding: 16px 12px 8px;
}

.money-container .money-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
  display: inline-block;
  z-index: 2;
}

.price-type {
  font-size: 14px;
  font-weight: 400;
  font-family: PingFangSC-Regular, PingFang SC;
  margin-left: 8px;
  color: rgba(0, 0, 0, 0.6);
}

.money-container .money-select-block {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  margin-top: 8px;
  row-gap: 8px;
  grid-row-gap: 8px;
}

.money-container .money-select-block .money-item-wrap {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}

.money-container .money-select-block .money-item {
  font-size: 14px;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  margin: 0 5px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 10px 0;
  text-align: center;
}

.money-container .cell {
  line-height: 48px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}

.money-container .cell .label {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  width: 60px;
}

.cell .buyer-info-input {
  font-size: 14px;
  color: #000;
  margin-left: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
}

/* 明细******** */
.detail-title {
  font-size: 16px;
  color: #000;
  font-weight: 700;
  font-family: PingFangSC-Medium, PingFang SC;
}

.van-popup--bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  min-height: 180px;
  padding: 16px 16px 72px;
  width: auto;
}

.van-popup--bottom img {
  position: absolute;
  right: 16px;
  top: 16px;
  width: 10px;
}

.van-popup--bottom .cell {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-top: 8px;
}

.van-popup--bottom .cell .title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  font-family: PingFangSC-Regular, PingFang SC;
}

.van-popup--bottom .cell .money {
  font-size: 14px;
  color: #000;
  margin-left: auto;
  font-family: PingFangSC-Regular, PingFang SC;
}

/* 首页按钮 **********/
.btn-home {
  width: 44px;
  height: 44px;
  background: #fff;
  border: 1px solid #007aaa;
  border-radius: 22px;
  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.1);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  position: fixed;
  bottom: 106px;
  right: 15px;
  z-index: 999;
}

.img-home {
  width: 20px;
  height: 20px;
}

.text-home {
  font-size: 10px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #007aaa;
}
</style>